export default __webpack_public_path__ + "static/media/Q10_給你精力充沛的能量.321fd5cf.mp4";